import { eHierarchy, eHierarchyLevel } from "../enums";

export interface HierarchyChildReadDto {
  id: string;
  name: string;
  hierarchyTag: string;
  parentTag: string;
  level: eHierarchyLevel;
  type: eHierarchy;
  tocMajorVersion?: number;
  tocMinorVersion?: number;
}

/**
 * Type guard that asserts whether a value conforms to the HierarchyChildReadDto shape.
 *
 * @param obj - Then object to check
 * @returns boolean
 */
export const isHierarchyChildReadDto = (obj: unknown): obj is HierarchyChildReadDto => {
  // Check object
  if (typeof obj !== "object" || obj === null) return false;
  // Check properties exist and types
  const chkObj = obj as HierarchyChildReadDto;
  if (typeof chkObj.id !== "string") return false;
  if (typeof chkObj.name !== "string") return false;
  if (typeof chkObj.hierarchyTag !== "string") return false;
  if (typeof chkObj.parentTag !== "string") return false;
  if (typeof chkObj.tocMajorVersion !== "undefined" && typeof chkObj.tocMajorVersion !== "number")
    return false;
  if (typeof chkObj.tocMinorVersion !== "undefined" && typeof chkObj.tocMinorVersion !== "number")
    return false;
  // Check enums
  if (!Object.values(eHierarchyLevel).includes(chkObj.level)) return false;
  if (!Object.values(eHierarchy).includes(chkObj.type)) return false;
  // Everything is good
  return true;
};
